import { AuthAction } from '../actions';
import { AuthConstant } from '../constants';

const initialState = AuthAction.storageGetAuth();

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case AuthConstant.SET_AUTH:
      return { ...state, ...payload };
    default:
      return state;
  }
};
